import React from 'react';
import { Chart } from 'react-google-charts';
import AppActions from '../../actions/app-actions';

export default class PeiCharts extends React.Component {
  constructor(props, state) {
    super(props, state);
    const self = this;
    self.timer = null;
    self.state = {
      devices: [],
      conn1min:0,
      conn5min:0,
      notSeen5min:0,
      notSeen1Day:0,
      allArtifacts : [],
      alarms:{'critAlarms':0, 'warnAlarms':0},
      refreshDevicesLength: 30000,
      refreshAlarmsLength: 30000,
    };
    // on render the store might not be updated so we resort to the API and let all later request go through the store
    // to be in sync with the rest of the UI
    self._refreshDevices().then(result => self.setState(result));
    self._refreshAlarms().then(result => self.setState(result));
  }
  componentDidMount() {
    var self = this;
    self.deviceTimer = setInterval(() => self._refreshDevices().then(result => self.setState(result)), self.state.refreshDevicesLength);
    self.alarmTimer = setInterval(() => self._refreshAlarms().then(result => self.setState(result)), self.state.refreshAlarmsLength);

  }
  componentWillUnmount() {
    clearInterval(this.deviceTimer);
    clearInterval(this.alarmTimer);
  }
  _refreshDevices() {
    var self = this;
    var artifacts = [];
    var allArtifacts= [['artifacts', 'version']];
    var conn1min = 0;
    var conn5min = 0;
    var notSeen1Day = 0;
    var notSeen5min = 0;


    return AppActions.getAllDevices()
      .then(devices => {
        var accu ={};
        accu['artifacts'] = {};
        accu['heartbeat'] = {'conn1min':0, 'conn5min': 0,  'notSeen5min' :0, 'notSeen1Day':0};

        self.setState({devices:devices});
        // now boil the list down to the ones that were not updated since yesterday
        const deviceInfo = devices.reduce((accu, device) => {
          var curTime = new Date();
          var d = new Date(device.updated_ts);
          var minutes = Math.floor((curTime - d) / 60000);

          if (typeof device.attributes !== 'undefined' && device.attributes.length>0) {
            var sortedAttributes = device.attributes.sort(function (a, b) {
              return a.name.localeCompare( b.name );
            });
            for (var key in sortedAttributes){
              if (sortedAttributes[key].name === 'artifact_name'){
                if (typeof accu.artifacts[sortedAttributes[key].value] == 'undefined' ){
                  accu.artifacts[sortedAttributes[key].value] = 1;
                } else {
                  accu.artifacts[sortedAttributes[key].value] += 1;
                }
              }
            }
          }
          if (minutes<=1 ) {
            accu.heartbeat['conn1min'] = ++conn1min;
          } else if (minutes > 1 && minutes <= 5 ) {
            accu.heartbeat['conn5min'] = ++conn5min;
          } else if (minutes > 5 && minutes <= 1440) {
            accu.heartbeat['notSeen5min'] = ++notSeen5min;
          } else if (minutes > 1440) {
            accu.heartbeat['notSeen1Day'] = ++notSeen1Day;
          }
          return accu;
        }, accu);
        for (var key in deviceInfo.artifacts){
          artifacts = [];
          artifacts.push(key);
          artifacts.push(deviceInfo.artifacts[key]);
          allArtifacts.push(artifacts);
        }
        self.setState({allArtifacts:allArtifacts, conn1min: deviceInfo.heartbeat.conn1min, conn5min:deviceInfo.heartbeat.conn5min, notSeen5min:deviceInfo.heartbeat.notSeen5min, notSeen1Day:deviceInfo.heartbeat.notSeen1Day});
      });
  }

  _refreshAlarms() {
    var self = this;
    return AppActions.getAllActions()
      .then(actions => {
        var accu = {};
        accu['critAlarms'] = 0;
        accu['warnAlarms'] = 0;
        // now boil the list down to the ones that were not updated since yesterday
        var alarms = actions.reduce((accu, action) => {
          var curTime = new Date();
          for (var i = 0; i < self.state.devices.length; i++){
            if(self.state.devices[i].id == action.device_id){
              var d = new Date(self.state.devices[i].updated_ts);
              break;
            }
          }
          var minutes = Math.floor((curTime - d) / 60000);
          if (minutes <= 1 && typeof action.alarms !== 'undefined' && action.alarms.length>0 ) {
            var deviceAlarm = action.alarms.split(',');
            var aType = '';
            for (i=0;i<deviceAlarm.length;i++) {
              if (deviceAlarm[i].charAt(0) === 'C') {
                aType = 'critAlarms';
                break;
              } else if (deviceAlarm[i].charAt(0) === 'W'){
                aType = 'warnAlarms';
              }
            }
            aType !== ''? accu[aType] +=1:'';
          }
          return accu;
        }, accu);
        self.setState({alarms:alarms});
      });
  }

  render() {
    var self = this;
    var heartbeatColorCode = [];

    if (self.state.conn1min > 0 ){
      heartbeatColorCode['0'] = {color: 'green' };
    }
    if (self.state.conn5min > 0){
      heartbeatColorCode['1'] = {color: 'yellow' };
    }
    if(self.state.notSeen5min > 0){
      heartbeatColorCode['2'] = {color: 'orange' };
    }
    if(self.state.notSeen1Day > 0){
      heartbeatColorCode['3'] = {color: 'red' };
    }

    var alarmsColorCode = [];

    alarmsColorCode['0'] = {color: 'red' };
    alarmsColorCode['1'] = {color: 'orange' };
    alarmsColorCode['2'] = self.state.conn1min ? {color: 'green' }: {color: 'red' };

    return (
      <div>
        <div style={Object.assign({ marginBottom: '30px', marginTop: '50px' }, this.props.styles)}>
          <div >
            <Chart
              width={'300px'}
              height={'300px'}
              chartType="PieChart"
              loader={<div>Loading Chart</div>}
              data={[
                ['Alarms', 'types'],
                ['Critical', self.state.alarms.critAlarms],
                ['Warning', self.state.alarms.warnAlarms],
                [self.state.conn1min ? 'Active':'Inactive', self.state.conn1min ? self.state.conn1min : (self.state.notSeen5min + self.state.notSeen1Day)],
              ]}
              options={{
                title: self.state.conn1min? 'Active alarms': 'No Active Alarms',
                titleTextStyle:{
                  fontSize: self.state.conn1min ? 17 : 18,
                  bold: true,
                },
                pieSliceText:'label',
                slices: alarmsColorCode,
                legend: {
                  position:'none'
                },
              }}
              rootProps={{ 'data-testid': '1' }}
            />
          </div>
          <div >
            <Chart
              width={'300px'}
              height={'300px'}
              chartType="PieChart"
              loader={<div>Loading Chart</div>}
              data={[
                ['Heartbeat', 'count'],
                ['Connected<1m', self.state.conn1min],
                ['Connected >1m & <5m', self.state.conn5min],
                ['Not seen>5m & <1day', self.state.notSeen5min],
                ['Not seen>1day', self.state.notSeen1Day],
              ]}
              options={{
                title: 'Heartbeat status',
                titleTextStyle:{
                  fontSize: 18,
                  bold: true,
                },
                pieSliceText:'label',
                slices: heartbeatColorCode,
                legend: {
                  position:'none'
                },
              }}
              rootProps={{ 'data-testid': '4' }}
            />
          </div>
          <div >
            <Chart
              width={'300px'}
              height={'300px'}
              chartType="PieChart"
              loader={<div>Loading Chart</div>}
              data={self.state.allArtifacts}
              options={{
                title: 'Artifact version',
                titleTextStyle:{
                  fontSize: 18,
                  bold: true,
                },
                pieSliceText:'label',
                legend: {
                  position:'none'
                },
              }}
              rootProps={{ 'data-testid': '1' }}
            />
          </div>
        </div>
      </div>
    );
  }
}
